import {
  getPremium,
  getSupplier,
  getSupplierPhotosCount,
  getSupplierVideosCount,
  getVideoToursCount,
} from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import MediaButtonSectionComp from '@bridebook/web/app-shared/components/supplier/sections/media-button-section/media-button-section';

const MediaButtonSection = () => {
  const supplier = useSelector(getSupplier);
  const videosCount = useSelector(getSupplierVideosCount);
  const photosCount = useSelector(getSupplierPhotosCount);
  const videoToursCount = useSelector(getVideoToursCount);
  const premium = useSelector(getPremium);

  if (!supplier) return null;

  return (
    <MediaButtonSectionComp
      supplier={supplier}
      premium={premium}
      videosCount={videosCount}
      photosCount={photosCount}
      videoToursCount={videoToursCount}
      isLoggedIn={false}
    />
  );
};

export default MediaButtonSection;
